import { points } from '@/socket'
import { mapState, mapActions } from 'vuex'

export default {
  mounted () {
    points.on('manual', async () => {
      this.getPointsInfo()
    })
    points.on('convert', async () => {
      this.getPointsInfo()
    })
  },

  methods: {
    ...mapActions('meta', { getAllMeta: 'get' }),
    ...mapActions('meta', ['getCashInfo', 'setNotif', 'setMeta', 'getManualInfo', 'getPointsInfo'])
  }
}
